import modular from "modujs";
import * as modules from "./_modules";
import "./_lazyload";
import "./_order";
import { setupAOS, setupIframes } from "./_animations";

setupIframes();

const app = new modular({
    modules: modules,
});

window.addEventListener('load', event => {
    const $style = document.getElementById("main-css");

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener("load", (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
});

function init() {
    app.init(app);
    document.documentElement.classList.add("is-loaded", "is-ready");
    document.documentElement.classList.remove("is-loading");

    // add body class when bottom navigation is display
    if ($('.app-navigation').length > 0) {
        $('body').addClass('with-bottom-navigation');
    }

    $('.btn-print').on('click', function(e) {
        e.preventDefault();

        var content = $('.ma-commande').clone();

        var $iframe = $('<iframe>', {
            style: 'position:absolute;width:0;height:0;border:0;visibility:hidden;',
        }).appendTo('body');

        var doc = $iframe[0].contentWindow.document;

        var styles = '';
        $('link[rel="stylesheet"], style').each(function() {
            styles += this.outerHTML;
        });

        doc.open();
        doc.write(`
        <html>
            <head>
                <title>Impression</title>
                ${styles}
                <style>
                    .ma-commande { width: 1112px; }
                    body { margin: 0; }
                </style>
            </head>
            <body>
                ${content.prop('outerHTML')}
            </body>
        </html>
    `);
        doc.close();

        $iframe[0].contentWindow.focus();
        setTimeout(function() {
            $iframe[0].contentWindow.print();
            $iframe.remove();
        }, 300);
    });



    setupAOS();
}
